"use client";
import React from "react";
import { useRouter } from "next/navigation";
import { Button } from "../atoms/button";

export function GoBack() {
  const router = useRouter();
  return <Button onClick={() => router.back()}>Go Back</Button>;
}
